import InputAdornment from "@mui/material/InputAdornment";
import CustomButton from "../../../components/CustomButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  SvgIcon,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import * as React from "react";
import {
  collapseMenu,
  isAuthPageAtom,
  selectedSidebarTab,
  sessionIdStatus,
  showErrorAlertDialog,
} from "../../../config/AppConfig";
import * as CONSTANT from "../../../constants/Constant";
import { Formik } from "formik";
import * as yup from "yup";
import Box from "@mui/material/Box";
import ConnectionStatus from "../../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../../utils/UseOnlineStatus";
import {
  saveToLocalStorage,
  getFromLocalStorage,
  deleteAllKeyFromLocalStorage,
  saveToLocalStorageJsonObject,
} from "../../../utils/localStorageUtils";
import CustomProgressDialog from "../../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../../components/ErrorAlertDialog";
import {
  ALERT,
  AUTHENTICATING_PLEASE_WAIT,
  ERROR,
  ERROR_WHILE_AUTHENTICATING_USER,
  ERROR_WHILE_RETRIEVING_BASIC_AUTH,
  FORGOT_PASSWORD,
  LOADING_CONFIGRATION_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  REMEMBER_ME,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../../constants/Strings";
import DebugLog from "../../../utils/DebugLog";
import {
  ACCESS_TOKKEN,
  BASIC_AUTH_TOKKEN,
  COMPANY_CODE,
  COMPANY_ID,
  COMPANY_NAME,
  IS_EXTERNAL_USER,
  LOGIN_ID,
  LOGIN_RESPONSE,
  MESSAGE_KEY,
  REMEMBER_ME_CHECKBOX,
  REMEMBER_USER_NAME,
  SESSION_ID,
  USER_ID,
  USER_NAME,
  USER_ROLE,
} from "../../../constants/LocalStorageKeyValuePairString";
import { ApiType } from "../../../services/ApiTags";
import { AuthContext } from "../../../context/AuthContext";
import { generateBasicAuthHeader } from "../../../services/BasicAuthHashing";
import useAxiosHook from "../../../hooks/UseAxios";
import config from "../../../services/configration/config";

function LoginFieldBox() {
  const navigate = useNavigate();
  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const isNetworkConnectionAvailable = UseOnlineStatus();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checked, setChecked] = useState(false);
  const [, setSelected] = useAtom(selectedSidebarTab);
  const [, setIsCollapsed] = useAtom(collapseMenu);
  const [showPassword, setShowPassword] = useState(false);
  const [,setSessionIdState] = useAtom(sessionIdStatus);

  const { setAuthDetails } = React.useContext(AuthContext);
  const { data, error, showProgressBar, fetchData } = useAxiosHook();


  useEffect(() => {
    updateSavedUserName();
    resetAllConfigration();
    getNewConfigration();
    showNoInternetSnackBar();
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate]);

  const resetAllConfigration = () => {
    setSelected(CONSTANT.FINANCE_DASHBOARD);
    setIsCollapsed(false);
    saveToLocalStorage(SESSION_ID, "");
    setAuthStatus(true);
    setError("");
    setErrorDialog(false);
    deleteAllKeyFromLocalStorage();
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const updateSavedUserName = () => {
    const isCheckboxRemembered = getFromLocalStorage(REMEMBER_ME_CHECKBOX);

    if (isCheckboxRemembered && isCheckboxRemembered === "true") {
      const userName = getFromLocalStorage(REMEMBER_USER_NAME);
      initialValues.emailValue = userName;
      setChecked(true);
    } else {
      setChecked(false);
    }
  };
  const getNewConfigration = () => {
    // const basicAuthTokken = getFromLocalStorage(BASIC_AUTH_TOKKEN);
    // if (basicAuthTokken === undefined || basicAuthTokken === null){
    //   requestBasicAuth(false);
    // }

    requestAuthToken(false)
      
  };

   // Generate oAuth token 
    const requestAuthToken = async (isLoginApiCallRequired) => {
    if (isNetworkConnectionAvailable) {
      setProgressbarText(LOADING_CONFIGRATION_PLEASE_WAIT);

    const tokenApiKey = process.env.REACT_APP_O_AUTH_TOKKEN_API_KEY;
    const formData = new URLSearchParams();
    formData.append("client_id", process.env.REACT_APP_O_AUTH_CLIENT_ID);
    formData.append("client_secret",  process.env.REACT_APP_O_AUTH_CLIENT_SECRET);
    formData.append("grant_type", process.env.REACT_APP_O_AUTH_GRANT_TYPE);

      try {
        const response = await axios.post(config.oAuthBaseUrl, formData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            apikey: tokenApiKey,
          },
        });
    
        console.log("Response:", response.data);
        saveToLocalStorage(ACCESS_TOKKEN, response.data.access_token);

        if (isLoginApiCallRequired) {
          saveToLocalStorage(LOGIN_ID, email);
          doSignUp(email, password);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
  };

  // Generate Basic Auth hHeader()
  const requestBasicAuth = (isLoginApiCallRequired) => {
    if (isNetworkConnectionAvailable) {
      setProgressbarText(LOADING_CONFIGRATION_PLEASE_WAIT);

      const headerTokken = generateBasicAuthHeader();
      const authToken = "BASIC " + headerTokken;

      fetchData(
        process.env.REACT_APP_BASIC_AUTH_API_URL,
        ApiType.BASIC_AUTH,
        ApiType.GET_METHOD,
        null,
        {
          headers: {
            Authorization: authToken,
          },
        },
        (data) => {
          saveToLocalStorage(MESSAGE_KEY, data.messageKey);
          saveToLocalStorage(BASIC_AUTH_TOKKEN, data.basicAuthToken);

          if (isLoginApiCallRequired) {
            saveToLocalStorage(LOGIN_ID, email);
            doSignUp(email, password);
          }
        }
      );
    }
  };

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };
  // {
  //       "requestId": "1740543416750784116",
  //       "loginId": "bizops",
  //       "contentDataObject": {
  //           "userName": "bizops",
  //           "password": "Ytlc@xm1234"
  //       }
  //   }
  async function doSignUp(email, pswd) {
    setProgressbarText(AUTHENTICATING_PLEASE_WAIT)
    const signInData = {
      userName: email,
      password: pswd,
    };
    const requestData = {
      //requestId: generateRequestId,
     // loginId: email,
      contentDataObject: signInData
    };
    // initializeEncryption(
    //   signInData,
    //   getFromLocalStorage(MESSAGE_KEY),
    //   ApiType.SIGN_IN
    // ).then((encryptedLoginData) => {
      saveToLocalStorage(LOGIN_ID, signInData.userName);

      fetchData(
        process.env.REACT_APP_LOGIN_API_URL,
        ApiType.SIGN_IN,
        ApiType.POST_METHOD,
        //encryptedLoginData,
        signInData,
        {},
        (data) => {
          if (data !== null) {
            const sessionId = data.result.sessionId;
            saveToLocalStorage(MESSAGE_KEY,data.result.messageKey)
            saveToLocalStorage(SESSION_ID, sessionId);
            setAuthDetails(data.result);
            setSessionIdState(sessionId);
            saveToLocalStorageJsonObject(
              LOGIN_RESPONSE,
              data.result.userAccessDetails.menuList
            );
            saveToLocalStorage(IS_EXTERNAL_USER,data.result.isExternalUser)
            if(data.result.isExternalUser==="Y"){
              saveToLocalStorage(COMPANY_CODE,data.result.companyCode)
              saveToLocalStorage(COMPANY_NAME,data.result.companyName)
              saveToLocalStorage(COMPANY_ID,data.result.companyId)
            }
            saveToLocalStorage(USER_ID, data.result.userId);
            saveToLocalStorage(USER_NAME, data.result.name);
            saveToLocalStorage(USER_ROLE, data.result.role);

            // open dashbaord on the basis of response type and login path
            goToDashboard();
          }
        }
      );
   // });
  }
  const handleFormSubmit = (values) => {
    if (isNetworkConnectionAvailable) {
      setEmail(values.emailValue);
      setPassword(values.passwordValue);

      if (checked === true) {
        const userName = values.emailValue;
        saveToLocalStorage(REMEMBER_USER_NAME, userName);
       
      } else {
        saveToLocalStorage(REMEMBER_USER_NAME, "");
        saveToLocalStorage(REMEMBER_ME_CHECKBOX, false);
      }

      if (getFromLocalStorage(ACCESS_TOKKEN) != null){
        doSignUp(values.emailValue, values.passwordValue);
      }else{
        setProgressbarText(LOADING_CONFIGRATION_PLEASE_WAIT)
        requestAuthToken(true)
      }
       
    } else {
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
    }
  };

  function showErrorAlert(title, content) {
    try {
      setError("");
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }
  const handleRemberMeClick = (event) => {
    setChecked(event.target.checked);
    saveToLocalStorage(REMEMBER_ME_CHECKBOX, event.target.checked);

    // if(event.target.checked===true){
    //   saveToLocalStorage(REMEMBER_ME_CHECKBOX,true)
    // }else{
    //   saveToLocalStorage(REMEMBER_ME_CHECKBOX,false)
    // }
  };
  //  login button click listener
  function goToDashboard() {
    setAuthStatus(false);
    navigate(CONSTANT.FINANCE_DASHBOARD);
  }

  useEffect(() => {
    if (showProgressBar) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);

 
  useEffect(() => {
    try{
    
    if (error) {
      if (error.data !== null && error.data !== undefined && error.data.responseCode !== null && error.data.responseCode !== "-1") {
        const message = error.response !== null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_AUTHENTICATING_USER + JSON.stringify(message)
        );
      } else if(error.data !== null && error.data !== undefined && error.data.errorCode === "ERR-YESSHOPADMINWEB103"){
        requestAuthToken(true);
      } else {
        const message =
          error.data !== null && error.data !== undefined ? error.data.displayErrorMessage : error.message;
          if(error.config.url==="/auth/BasicAuth/88888888"){
            showErrorAlert(
             ERROR,
             ERROR_WHILE_RETRIEVING_BASIC_AUTH + JSON.stringify(message)
           );
         }else{
            showErrorAlert(
             ERROR,
             ERROR_WHILE_AUTHENTICATING_USER + JSON.stringify(message)
           );  
         }
      }
    }
  }catch(error){
      DebugLog(error+"")
  }
  }, [error]);
  return (
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        <Box sx={{ mt: 1 }}>
          <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box>
                  
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="User Name"
                    name="emailValue"
                    autoComplete="current"
                    autoFocus
                    onBlur={handleBlur}
                    initialValues={email}
                    onChange={handleChange}
                    value={values.emailValue}
                    error={!!touched.emailValue && !!errors.emailValue}
                    helperText={touched.emailValue && errors.emailValue}
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Box sx={{ margin: "0 8px" }}>
                            <SvgIcon>
                              <svg
                                width="15"
                                height="19"
                                viewBox="0 0 15 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.7509 18.2637C13.9791 18.2637 14.1613 18.024 14.1477 17.7392C13.9906 14.5454 12.4095 11.8316 10.187 10.5747C9.32857 10.0811 8.36338 9.82348 7.38266 9.82619C6.40194 9.82891 5.43808 10.0919 4.58216 10.5902C2.37395 11.8541 0.805641 14.5588 0.649217 17.7392C0.634997 18.0212 0.817153 18.2637 1.04536 18.2637H13.7509Z"
                                  stroke="#2F3BF5"
                                  strokeWidth="1.17"
                                  strokeMiterlimit="10"
                                />
                                <path
                                  d="M7.39844 10.6699C9.72839 10.6699 11.6172 8.59224 11.6172 6.0293C11.6172 3.46635 9.72839 1.38867 7.39844 1.38867C5.06849 1.38867 3.17969 3.46635 3.17969 6.0293C3.17969 8.59224 5.06849 10.6699 7.39844 10.6699Z"
                                  fill="white"
                                  stroke="#FF0084"
                                  strokeWidth="1.17"
                                  strokeMiterlimit="10"
                                />
                              </svg>
                            </SvgIcon>
                          </Box>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="passwordValue"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.passwordValue}
                    error={!!touched.passwordValue && !!errors.passwordValue}
                    helperText={touched.passwordValue && errors.passwordValue}
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Box sx={{ margin: "0 8px" }}>
                            <SvgIcon>
                              <svg
                                width="15"
                                height="19"
                                viewBox="0 0 15 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.60298 0.588867C4.89042 0.588867 2.69389 2.7854 2.69389 5.49796V8.77069H1.87571C1.20288 8.77069 0.648438 9.32513 0.648438 9.99796V17.3616C0.648438 18.0344 1.20288 18.5889 1.87571 18.5889H13.3303C14.0031 18.5889 14.5575 18.0344 14.5575 17.3616V9.99796C14.5575 9.32513 14.0031 8.77069 13.3303 8.77069H12.5121V5.49796C12.5121 2.7854 10.3155 0.588867 7.60298 0.588867ZM7.60301 1.40693C9.87645 1.40693 11.6939 3.2244 11.6939 5.49784V8.77056H3.5121V5.49784C3.5121 3.2244 5.32957 1.40693 7.60301 1.40693ZM13.3304 9.58891H1.87582C1.6421 9.58891 1.46673 9.76429 1.46673 9.998V17.3616C1.46673 17.5954 1.6421 17.7707 1.87582 17.7707H13.3304C13.5641 17.7707 13.7395 17.5954 13.7395 17.3616V9.998C13.7395 9.76429 13.5641 9.58891 13.3304 9.58891Z"
                                  fill="#2D43EC"
                                />
                                <path
                                  d="M2.69389 8.77069V8.99569H2.91889V8.77069H2.69389ZM12.5121 8.77069H12.2871V8.99569H12.5121V8.77069ZM11.6939 8.77056V8.99556H11.9189V8.77056H11.6939ZM3.5121 8.77056H3.2871V8.99556H3.5121V8.77056ZM2.91889 5.49796C2.91889 2.90966 5.01469 0.813867 7.60298 0.813867V0.363867C4.76616 0.363867 2.46889 2.66113 2.46889 5.49796H2.91889ZM2.91889 8.77069V5.49796H2.46889V8.77069H2.91889ZM1.87571 8.99569H2.69389V8.54569H1.87571V8.99569ZM0.873437 9.99796C0.873437 9.44939 1.32714 8.99569 1.87571 8.99569V8.54569C1.07861 8.54569 0.423438 9.20086 0.423438 9.99796H0.873437ZM0.873437 17.3616V9.99796H0.423438V17.3616H0.873437ZM1.87571 18.3639C1.32714 18.3639 0.873437 17.9102 0.873437 17.3616H0.423438C0.423438 18.1587 1.07861 18.8139 1.87571 18.8139V18.3639ZM13.3303 18.3639H1.87571V18.8139H13.3303V18.3639ZM14.3325 17.3616C14.3325 17.9102 13.8788 18.3639 13.3303 18.3639V18.8139C14.1274 18.8139 14.7825 18.1587 14.7825 17.3616H14.3325ZM14.3325 9.99796V17.3616H14.7825V9.99796H14.3325ZM13.3303 8.99569C13.8788 8.99569 14.3325 9.44939 14.3325 9.99796H14.7825C14.7825 9.20086 14.1274 8.54569 13.3303 8.54569V8.99569ZM12.5121 8.99569H13.3303V8.54569H12.5121V8.99569ZM12.2871 5.49796V8.77069H12.7371V5.49796H12.2871ZM7.60298 0.813867C10.1913 0.813867 12.2871 2.90966 12.2871 5.49796H12.7371C12.7371 2.66113 10.4398 0.363867 7.60298 0.363867V0.813867ZM11.9189 5.49784C11.9189 3.10013 10.0007 1.18193 7.60301 1.18193V1.63193C9.75219 1.63193 11.4689 3.34866 11.4689 5.49784H11.9189ZM11.9189 8.77056V5.49784H11.4689V8.77056H11.9189ZM3.5121 8.99556H11.6939V8.54556H3.5121V8.99556ZM3.2871 5.49784V8.77056H3.7371V5.49784H3.2871ZM7.60301 1.18193C5.20531 1.18193 3.2871 3.10013 3.2871 5.49784H3.7371C3.7371 3.34866 5.45384 1.63193 7.60301 1.63193V1.18193ZM1.87582 9.81391H13.3304V9.36391H1.87582V9.81391ZM1.69173 9.998C1.69173 9.88856 1.76637 9.81391 1.87582 9.81391V9.36391C1.51784 9.36391 1.24173 9.64003 1.24173 9.998H1.69173ZM1.69173 17.3616V9.998H1.24173V17.3616H1.69173ZM1.87582 17.5457C1.76637 17.5457 1.69173 17.4711 1.69173 17.3616H1.24173C1.24173 17.7196 1.51784 17.9957 1.87582 17.9957V17.5457ZM13.3304 17.5457H1.87582V17.9957H13.3304V17.5457ZM13.5145 17.3616C13.5145 17.4711 13.4398 17.5457 13.3304 17.5457V17.9957C13.6883 17.9957 13.9645 17.7196 13.9645 17.3616H13.5145ZM13.5145 9.998V17.3616H13.9645V9.998H13.5145ZM13.3304 9.81391C13.4398 9.81391 13.5145 9.88855 13.5145 9.998H13.9645C13.9645 9.64003 13.6883 9.36391 13.3304 9.36391V9.81391Z"
                                  fill="#2D43EC"
                                />
                                <path
                                  d="M7.60334 13.1958C8.06005 13.1958 8.42152 13.5573 8.42152 14.014C8.42152 14.4707 8.06005 14.8322 7.60334 14.8322C7.14662 14.8322 6.78516 14.4707 6.78516 14.014C6.78516 13.5573 7.14662 13.1958 7.60334 13.1958Z"
                                  fill="#EA3583"
                                  stroke="#EA3583"
                                  strokeWidth="0.675"
                                />
                              </svg>
                            </SvgIcon>
                          </Box>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                            {/* <SvgIcon>
                            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M9.94872 0.288574C13.8477 0.288574 18.7362 2.92658 19.7988 6.85366L19.8488 7.03857L19.7988 7.22349C18.7362 11.1506 13.8477 13.7886 9.94872 13.7886C6.0497 13.7886 1.16122 11.1506 0.0986679 7.22349L0.0488281 7.03857L0.0986679 6.85366C1.16122 2.92658 6.0497 0.288574 9.94872 0.288574ZM1.5694 7.03858C2.55488 10.1774 6.72593 12.3487 9.94876 12.3487C13.1716 12.3487 17.3426 10.1777 18.3281 7.03858C17.3426 3.89951 13.1716 1.72843 9.94876 1.72843C6.72593 1.72843 2.55488 3.89951 1.5694 7.03858ZM10.0012 3.54185C7.98059 3.54185 6.33651 5.15674 6.33651 7.14146C6.33651 9.12619 7.98059 10.7411 10.0012 10.7411C12.0218 10.7411 13.6659 9.12619 13.6659 7.14146C13.6659 5.15674 12.022 3.54185 10.0012 3.54185ZM7.80228 7.14147C7.80228 8.33243 8.7886 9.30124 10.0011 9.30124C11.2136 9.30124 12.1999 8.33243 12.1999 7.14147C12.1999 5.95051 11.2136 4.9817 10.0011 4.9817C8.7886 4.9817 7.80228 5.95051 7.80228 7.14147Z" fill="#C4C4C4"/>
                              </svg>
                            </SvgIcon> */}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleRemberMeClick}
                        color="primary"
                      />
                    }
                    label={REMEMBER_ME}
                  />

                  {/* <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    Sign In
                  </Button> */}

                  <Box sx={{ mt: 2, mb: 2 }}>

                    <CustomButton
                      btnBG={"#FF0084"}
                      type={"submit"}
                      btnTxt={"Log In"}
                    ></CustomButton>

                  </Box>

                  {/* Form Elements */}
                  <Grid container direction={"row"} spacing={3} justifyContent={"space-between"}>
                    
                    <Grid item mt={1}>
                      {/* <Link
                        href="/forgotUsername"
                        variant="body2"
                        sx={{
                          textDecoration: "none",
                          fontWeight: "500",
                          fontSize: "0.75rem",
                        }}
                      >
                        {FORGOT_USERNAME}
                      </Link> */}
                    </Grid>
                    <Grid item mt={1}>
                      <Link
                        href="/ForgotPassword"
                        variant="body2"
                        sx={{
                          textDecoration: "none",
                          fontWeight: "500",
                          fontSize: "0.75rem",
                        }}
                      >
                        {FORGOT_PASSWORD}
                      </Link>
                    </Grid>
                    {/* <Grid item>
                      <Link href="#" variant="body2">
                        {DONT_HAVE_A_ACCOUNT_SIGNUP}
                      </Link>
                    </Grid> */}
                  </Grid>
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      </SnackbarProvider>
    </Box>
  );
}

export default LoginFieldBox;

const checkoutSchema = yup.object().shape({
  emailValue: yup.string().required("UserName is Required"),
  passwordValue: yup.string().required("Password is Required"),
});

const initialValues = {
  emailValue: "",
  passwordValue: "",
};
